import * as fromEsareActions from '../actions/esare.actions';
import {inject, Injectable} from '@angular/core';
import { Actions, createEffect, ofType} from '@ngrx/effects';
import { Action} from '@ngrx/store';
import { catchError, map, switchMap} from 'rxjs/operators';
import { of} from 'rxjs/internal/observable/of';
import { Observable} from 'rxjs';
import { EsareRestService } from '../../services/api/esare.rest-service';

@Injectable()
export class EsareEffects {
    private actions$ = inject(Actions);
    private esareRestService = inject(EsareRestService);


    loadSupplements$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType<fromEsareActions.InitLoadAllSupplements>(fromEsareActions.EsareActionTypes.INIT_LOAD_ALL_SUPPLEMENTS))
            .pipe(switchMap(() =>
                    this.esareRestService.loadAllSupplements().pipe(
                        map(data => new fromEsareActions.LoadAllSupplementsComplete(data.returnObject)),
                        catchError((error) => of(new fromEsareActions.LoadAllSupplementsFailed(error)))
                    )
                )
            )
    );
}
